import { DatePicker, Input, Pagination, Select, Table } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Loader from "components/loader";
import { useNavigate, useParams } from "react-router-dom";
import { getEventMarketPL } from "../../redux/slice/eventMarketPL/eventMarketPLSlice";

const MatchDetailList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { match_id, selection_id } = useParams();
    const { data, loading } = useSelector((state) => state.eventMarketPL);
    console.log('data:', data)
    const { userdata, isAuthenticated } = useSelector((state) => state.authSlice);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const [filteredData, setFilteredData] = useState();

    const [eventType, setEventType] = useState("4");
    const [status, setStatus] = useState("Settled");
    const [fromDate, setFromDate] = useState(dayjs().subtract(1, 'day'));
    const [toDate, setToDate] = useState(dayjs());
    const paginatedData = filteredData?.slice(startIndex, endIndex);
    let locale = {
        emptyText: 'No data!',
    };
    const handlePageSizeChange = (e) => {
        setPageSize(e);
        setCurrent(1);
    };

    const columns = [
        {
            title: 'S.No.',
            dataIndex: 'index',
            render: (_, record, index) => (
                <span>{(index + 1)}</span>
            )
        },
        {
            title: "Event Name",
            dataIndex: "event_name",
            render: (_, record) => (
                <span className=" text-[#212529] text-[0.813rem] ">
                    {record.event_name}
                </span>
            ),
        },
        {
            title: "Market",
            dataIndex: "market_name",
            render: (_, record) => (
                <span className=" text-[#212529] text-[0.813rem] ">
                    {record.market_name}
                </span>
            ),
        },
        {
            title: 'P_L',
            dataIndex: 'total_p_l	',
            render: (_, record) => (
                <span className={`${record?.total_p_l >= 0 ? 'text-[#508d0e]' : 'text-[#d50000]'} `}>{record?.total_p_l ? Number(record?.total_p_l).toFixed(2) : '-'}</span>
            ),
        },
        {
            title: 'Comm',
            dataIndex: 'P_L	',
            render: (_, record) => (
                // <span className={`${record?.commision >= 0 ? 'text-[#508d0e]' : 'text-[#d50000]'} `}>{Number(record?.commision).toFixed(2) || '-'}</span>
                <span className={`${record?.commision >= 0 ? 'text-[#508d0e]' : 'text-[#d50000]'} `}>{record?.commision ? Number(record?.commision).toFixed(2) : '-'}</span>
            ),
        },
        {
            title: 'Total',
            dataIndex: 'total_p_l',
            render: (_, record) => (
                <span className={`${record?.total_p_l >= 0 ? 'text-[#508d0e]' : 'text-[#d50000]'} `}>{record?.total_p_l ? Number(record?.total_p_l).toFixed(2) : '-'}</span>
            ),
        },
        {
            title: "Result",
            dataIndex: "event_name",
            render: (_, record) => (
                <span className=" text-[#212529] text-[0.813rem] ">
                    {record.reusult || '-'}
                </span>
            ),
        },
        {
            title: "Date",
            dataIndex: "updated_at",
            render: (_, record) => {
                return (
                    <span className=" text-[#212529] text-[0.813rem] ">
                        {new Date(record.updated_at).toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                        })}
                    </span>
                );
            },
        },
        {
            title: "Action",
            dataIndex: "event_name",
            render: (_, record) => (
                <span className=" text-[#212529] underline cursor-pointer text-[0.813rem] "
                    onClick={() => {
                        navigate(`/usershowBets/${match_id}/${record?.market_name == "Fancy" ? record?.selection_id : record?.market_id}/${record?.market_name == "Fancy" ? 'true' : 'false'}`)
                    }}
                >
                    Show Bets
                </span>
            ),
        },
    ];
    useEffect(() => {
        if (match_id && selection_id) {
            const data = {
                match_id: match_id,
                selection_id: selection_id
            }
            if (isAuthenticated) {
                dispatch(getEventMarketPL(data))
            }
        }
    }, [match_id, selection_id, isAuthenticated])

    // console.log('data:', data)
    return (
        <>
            {
                loading && <Loader />
            }
            <div className='relative min-w-full'>
                <div className='grid grid-cols-12 lg:px-[6px] mt-[.5rem] lg:mt-0'>
                    <div className='col-span-12'>
                        <div className='relative w-full'>
                            <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>Match Details</p>
                        </div>
                        <div className="bg-[#fff] text-[#000] mb-[10px] min-h-[500px] w-full">
                            <div className='col-span-12'>
                                <Table
                                    locale={locale}
                                    columns={columns}
                                    bordered
                                    dataSource={data}
                                    pagination={false}
                                />
                            </div>
                        </div>

                    </div >

                </div >
            </div >
        </>
    )
}
export default MatchDetailList